module.exports = __webpack_public_path__ + "static/selects-order-do-bccc76bb4dcd0f532f1e545146b84f02.png";